import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '../api/index';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
      meta: { noAuth: true },
    },
    {
      path: '/',
      component: () => import(/* webpackChunkName: "layout" */ '../views/Layout.vue'),
      redirect: '/articles',
      children: [
        {
          path: 'articles',
          name: 'ArticlesList',
          component: () => import(/* webpackChunkName: "articles" */ '../views/ArticlesList.vue'),
          meta: { title: '套餐专区' },
        },
        {
          path: 'article/create',
          name: 'ArticleCreate',
          component: () => import(/* webpackChunkName: "article-edit" */ '../views/ArticleEdit.vue'),
          meta: { title: '新建文章' },
        },
        {
          path: 'article/edit/:id',
          name: 'ArticleEdit',
          component: () => import(/* webpackChunkName: "article-edit" */ '../views/ArticleEdit.vue'),
          meta: { title: '编辑文章' },
        },
        {
          path: 'categories',
          name: 'CategoriesList',
          component: () => import(/* webpackChunkName: "categories" */ '../views/CategoriesList.vue'),
          meta: { title: '分类管理' },
        },
        {
          path: 'products',
          name: 'ProductsList',
          component: () => import(/* webpackChunkName: "products" */ '../views/ProductsList.vue'),
          meta: { title: '单品资料管理' },
        },
        {
          path: 'product/create',
          name: 'ProductCreate',
          component: () => import(/* webpackChunkName: "product-edit" */ '../views/ProductEdit.vue'),
          meta: { title: '新建单品' },
        },
        {
          path: 'product/edit/:id',
          name: 'ProductEdit',
          component: () => import(/* webpackChunkName: "product-edit" */ '../views/ProductEdit.vue'),
          meta: { title: '编辑单品' },
        },
        {
          path: 'free',
          name: 'FreeList',
          component: () => import(/* webpackChunkName: "free" */ '../views/FreeList.vue'),
          meta: { title: '免费专区管理' },
        },
        {
          path: 'free/create',
          name: 'FreeCreate',
          component: () => import(/* webpackChunkName: "free-edit" */ '../views/FreeEdit.vue'),
          meta: { title: '新建免费资源' },
        },
        {
          path: 'free/edit/:id',
          name: 'FreeEdit',
          component: () => import(/* webpackChunkName: "free-edit" */ '../views/FreeEdit.vue'),
          meta: { title: '编辑免费资源' },
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
          meta: { title: '系统设置' },
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.noAuth) {
    next();
  } else {
    const token = getToken();
    if (token) {
      next();
    } else {
      next('/login');
    }
  }
});

export default router;
